// removed by extract-text-webpack-plugin
module.exports = {"column":"_3nhgz4m9gSDGU4JXH3GPLw","imageContainer":"_1bBIg2X3hGSXPbN0EZ2C1y","content":"_1wgInNVdoyVvI2MrNFXsdJ","title":"_2VdVY5A0-hYVLTM8qGuWF3","p":"_5EuEYXkD9JS7baIPcM3YK"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Benefits/Benefit/styles.scss
 ** module id = 469
 ** module chunks = 0
 **/